module.exports = __webpack_public_path__ + "static/media/sort-27.fcfd70a8.svg";